/**
 * Currency / geo picker modal.
 *
 * Opens the localization form once on arrival so the shopper picks a shipping
 * country and presentment currency before browsing. Follows the same open/close
 * conventions as the password modal: `hidden` + `.is-open`, double-rAF enter,
 * instant exit, focus trap, and a scroll lock on <html>.
 */
(function () {
  if (window.themeGeoPickerBound) return;
  window.themeGeoPickerBound = true;

  var OPEN_CLASS = 'geo-picker-open';
  var STORAGE_KEY = 'theme:geo-picker:seen';
  var FOCUSABLE =
    'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';

  var lastTrigger = null;
  var openTimer = null;

  function modal() {
    return document.getElementById('GeoPicker');
  }

  function isTrue(node, attribute) {
    return node && node.getAttribute(attribute) === 'true';
  }

  function isOpen(node) {
    return !!node && node.classList.contains('is-open');
  }

  function store(node) {
    try {
      return node.getAttribute('data-trigger') === 'session'
        ? window.sessionStorage
        : window.localStorage;
    } catch (error) {
      return null;
    }
  }

  function hasSeen(node) {
    if (node.getAttribute('data-trigger') === 'always') return false;
    try {
      var bucket = store(node);
      return !!bucket && bucket.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function markSeen(node) {
    if (isTrue(node, 'data-keep-open')) return;
    try {
      var bucket = store(node);
      if (bucket) bucket.setItem(STORAGE_KEY, '1');
    } catch (error) {
      /* Private browsing blocks writes; the popup simply shows again. */
    }
  }

  function open(trigger) {
    if (document.querySelector('cart-overlays dialog[open]')) return;
    var node = modal();
    if (!node || isOpen(node)) return;

    lastTrigger = trigger || null;
    node.removeAttribute('hidden');
    document.documentElement.classList.add(OPEN_CLASS);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        node.classList.add('is-open');
      });
    });

    /*
      The panel takes focus, not the country select.
      Landing on the select put a live control under the keyboard before the
      shopper had read a word of the panel, and a select answers an arrow key
      by changing its value — so Down, pressed by someone expecting to scroll,
      silently changed the market they were about to browse. The panel is
      labelled by the heading, so focusing it announces the dialog and its
      title and leaves the first Tab to reach the controls.
    */
    var panel = node.querySelector('.geo-picker__panel');
    if (panel) panel.focus();
    else {
      var field = node.querySelector(FOCUSABLE);
      if (field) field.focus();
    }
  }

  function close(force) {
    var node = modal();
    if (!isOpen(node)) return;
    if (isTrue(node, 'data-keep-open') && force !== true) return;

    // Hiding in the same tick means the exit never feels like it lags the click.
    node.classList.remove('is-open');
    node.setAttribute('hidden', '');
    document.documentElement.classList.remove(OPEN_CLASS);
    markSeen(node);

    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  function trapFocus(event) {
    var node = modal();
    if (!isOpen(node)) return;

    var items = Array.prototype.filter.call(node.querySelectorAll(FOCUSABLE), function (item) {
      return item.offsetParent !== null;
    });
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function init() {
    var node = modal();
    if (!node) return;

    if (isTrue(node, 'data-keep-open')) {
      open(null);
      return;
    }

    if (hasSeen(node)) return;

    var delay = parseInt(node.getAttribute('data-delay'), 10) || 0;
    openTimer = window.setTimeout(function () {
      open(null);
    }, delay);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var opener = event.target.closest('[data-geo-picker-open]');
    if (opener) {
      event.preventDefault();
      window.clearTimeout(openTimer);
      open(opener);
      return;
    }

    if (event.target.closest('[data-geo-picker-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    var node = modal();
    if (!isOpen(node)) return;

    if (event.key === 'Tab') {
      trapFocus(event);
      return;
    }

    if ((event.key === 'Escape' || event.key === 'Esc') && isTrue(node, 'data-dismissible')) {
      close();
    }
  });

  // A submitted choice counts as seen, so the reload does not re-open the popup.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form instanceof HTMLFormElement && form.id === 'GeoPickerForm') {
      markSeen(modal());
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.themeGeoPicker = { open: open, close: close };
})();
